import React from 'react';

import { SMSChallengeCode } from '../components';
import LoginBase, { LoginBaseProps } from '../components/LoginBase';

export interface SMSChallengeCodePageProps extends LoginBaseProps {}

export const SMSChallengeCodePage: React.FC<SMSChallengeCodePageProps> = ({
  ...loginBaseProps
}) => {
  return (
    <LoginBase {...loginBaseProps}>
      <SMSChallengeCode />
    </LoginBase>
  );
};
